import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SearchDescriptionChannelLogoContainer = styled.div<React.CSSProperties>`
  align-items: center;
  display: flex;
  height: ${90 * Screen.widthRatio}px;
`;

export default SearchDescriptionChannelLogoContainer;
